export default {"src":"/_next/static/media/Direction.50d5b368.svg","height":12,"width":10};